import { IonActionSheet, IonIcon } from '@ionic/react'
import { ExpandMore } from '@mui/icons-material'
import HomeIcon from '@mui/icons-material/Home'
import { ListItemIcon, ListItemText, Menu, MenuItem } from '@mui/material'
import { Object } from '@vae/server/dist/client'
import { close, homeSharp } from 'ionicons/icons'
import React, { useContext, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { logEvent } from '../../analytics/utils/firebaseUtils'
import { AppContext } from '../../contexts/AppContext'
import useUser from '../../contexts/hooks/useUser'
import { ObjectContext } from '../../contexts/objectContext/ObjectContext'

interface Props {}

const ContractCard: React.FC<Props> = () => {
	const { streetAddress, zipCode, city, houseNumber, objectOptions } = useContext(ObjectContext)
	const { isMobileView } = useContext(AppContext)

	const { t } = useTranslation('components_contractCard')

	const { user, setUser } = useUser()

	const [listOpen, setListOpen] = useState(false)
	const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)

	const handleDesktopClick = (event: React.MouseEvent<HTMLElement>) => {
		setAnchorEl(event.currentTarget)
		setListOpen(true)
	}

	const handleClose = () => {
		setAnchorEl(null)
		setListOpen(false)
		logEvent('click-generic-cancel')
	}

	const selectOption = (newObject: Object) => {
		if (!user || !newObject.id) return

		setUser({
			selectedObject: newObject.id,
		})
		setListOpen(false)
		setAnchorEl(null)
	}

	const objectOptionButtons =
		objectOptions.map(objectOption => ({
			text: `${objectOption.streetAddress}`,
			icon: homeSharp,
			handler: () => selectOption(objectOption),
		})) ?? []

	if (streetAddress)
		return (
			<div className='card bg-white dark:bg-brand-primary-200-dark drop-shadow-md'>
				<h1 className='text-text-grey-300 dark:text-white text-lg'>{t('kohde')}</h1>
				<div className='content-container'>
					<IonIcon
						icon={homeSharp}
						className='w-4 h-4 bg-brand-primary-200-light text-brand-primary-100-light dark:bg-brand-secondary-100-dark dark:text-brand-primary-100-dark'
					/>
					<div className='address'>
						<span className='street tracking-wide text-text-dark dark:text-white'>
							<div className='street'>{streetAddress}</div>
							<div className='house-number'>{houseNumber}</div>
						</span>
						<div className='text-text-grey-200 dark:text-text-grey-100'>
							<span>{zipCode} </span>
							<span>{city}</span>
						</div>
					</div>
				</div>

				{objectOptions.length > 1 && (
					<div
						className='change-button hover flex items-center justify-center gap-2 tracking-wide bg-brand-primary-100-light text-white dark:bg-brand-primary-100-dark'
						onClick={isMobileView ? () => setListOpen(state => !state) : handleDesktopClick}
					>
						{t('vaihda', { ns: 'common' })}
						<ExpandMore />
					</div>
				)}

				{isMobileView && (
					<IonActionSheet
						isOpen={objectOptions.length > 1 && listOpen}
						onDidDismiss={() => setListOpen(false)}
						header={t('valitseKohde')}
						buttons={[
							...objectOptionButtons,
							{
								text: t('peruuta', { ns: 'common' }),
								role: 'cancel',
								icon: close,
								handler: () => {
									logEvent('click-generic-cancel')
								},
							},
						]}
					/>
				)}

				{!isMobileView && (
					<Menu anchorEl={anchorEl} open={listOpen} onClose={handleClose}>
						{objectOptions.map(objectOption => (
							<MenuItem key={objectOption.id} onClick={() => selectOption(objectOption)}>
								<ListItemIcon>
									<HomeIcon fontSize='small' />
								</ListItemIcon>
								<ListItemText>{objectOption.streetAddress}</ListItemText>
							</MenuItem>
						))}
					</Menu>
				)}
			</div>
		)
	else return null
}

export default ContractCard
